import type { ContestSnapshot } from "./contest-types.js";
import type { RoundSnapshotV3 } from "../round/round-types.js";

export type HoleBonusKind = "longest-drive" | "closest-to-pin";
export interface HoleBonus {
  holeNumber: number;
  kind: HoleBonusKind;
  /** Null records no winner; it never invents a score or a stroke. */
  winnerId: string | null;
}
export interface SetHoleBonus extends HoleBonus {
  enabled: boolean;
}

export const holeBonusNames: Record<HoleBonusKind, string> = {
  "longest-drive": "Longest Drive",
  "closest-to-pin": "Closest to Pin",
};

export function holeBonusEffect(format: ContestSnapshot["format"]): string {
  return format === "match-play"
    ? "+1 match point"
    : format === "stableford"
      ? "−1 Stableford point"
      : "−1 stroke";
}

export function adjustedContestTotal(
  value: number | null,
  bonusCount: number,
): number | null {
  return value === null ? null : value - bonusCount;
}

/** A physical hole belongs to its latest agreed segment, never two contests. */
export function contestHoleBonuses(
  snapshot: RoundSnapshotV3,
  contest: ContestSnapshot,
): HoleBonus[] {
  const contests = [
    snapshot.mainContest,
    ...(snapshot.remainderContests ?? []),
  ];
  return (snapshot.holeBonuses ?? []).filter(
    (bonus) =>
      contests.findLast((item) => item.holeNumbers.includes(bonus.holeNumber))
        ?.id === contest.id,
  );
}

export function playerBonusCount(
  snapshot: RoundSnapshotV3,
  contest: ContestSnapshot,
  participantId: string,
  holes = contest.holeNumbers,
): number {
  return contestHoleBonuses(snapshot, contest).filter(
    (bonus) =>
      bonus.winnerId === participantId && holes.includes(bonus.holeNumber),
  ).length;
}
